// Review SMS status card after saving is disabled for now (see notices below).
// import InvitationStatus from "@/modules/reviews/InvitationStatus";
import { useState } from "react";
import { bankGatewayLabel } from "@/services/payment/bankGateway";
import useIsSmall from "@/hooks/useIsSmall";
import AddPaymentMobile from "./mobileView";
import AddPaymentDesktopView from "./desktopView";
import { useParams } from "react-router-dom";
import { useGetAppointmentDepositById } from "@/services/appointment/hooks/useGetAppointmentDepositById";
import { MerchantAppointmentQueueDto } from "@/models/club";
import { useCreateFactor } from "@/services/payment/utils";
import { Alert, Button, Group, LoadingOverlay, Text } from "@mantine/core";

function AddPayment() {
  const isSmall = useIsSmall();
  const { appId } = useParams();
  const { data, isFetching: fetchingLoading } = useGetAppointmentDepositById({
    id: Number(appId || "0"),
  });
  const {
    mutate,
    isLoading,
    pendingRecovery,
    recover,
    // data: createdInvoice,
  } = useCreateFactor();
  const [formVersion, setFormVersion] = useState(0);

  const notices = (
    <>
      {data && (
        <Group gap="xs" p="sm">
          <Text size="sm" c="dimmed">
            درگاه پرداخت نوبت:
          </Text>
          <Text size="sm">
            {bankGatewayLabel(
              (data as MerchantAppointmentQueueDto).bankGateway,
            )}
          </Text>
        </Group>
      )}
      {pendingRecovery && (
        <Alert color="yellow" title="نتیجه ثبت فاکتور مشخص نیست" style={{ flexShrink: 0 }}>
          <Text size="sm" mb="xs">
            برای جلوگیری از فاکتور تکراری، ابتدا نتیجه درخواست قبلی را بررسی کنید.
          </Text>
          <Button
            loading={isLoading}
            onClick={() =>
              void recover()
                .then(() => setFormVersion((v) => v + 1))
                .catch(() => {})
            }
          >
            بازیابی نتیجه فاکتور
          </Button>
        </Alert>
      )}
      {/* Disabled for now: review SMS status card on the invoice page.
      {createdInvoice?.purchaseId &&
        createdInvoice.reviewInvitation?.requested && (
          <InvitationStatus
            key={createdInvoice.purchaseId}
            purchaseId={createdInvoice.purchaseId}
          />
        )} */}
    </>
  );

  // Mobile: a height-limited, disabled <fieldset> clipped the recovery alert (and its only button) to its
  // title and stopped the sticky header partway down. The mobile view shows the notices under its header
  // and only locks submitting while the previous result is unknown.
  if (isSmall)
    return (
      <>
        <LoadingOverlay visible={fetchingLoading} />
        <AddPaymentMobile
          key={formVersion}
          mutate={mutate}
          appointment={data as MerchantAppointmentQueueDto}
          isLoading={isLoading}
          locked={pendingRecovery}
          notices={notices}
        />
      </>
    );

  return (
    <>
      <LoadingOverlay visible={fetchingLoading} />
      {notices}
      <fieldset
        key={formVersion}
        disabled={pendingRecovery || isLoading}
        style={{
          border: 0,
          padding: 0,
          margin: 0,
          minWidth: 0,
          height: "100%",
        }}
      >
        <AddPaymentDesktopView
          appointment={data as MerchantAppointmentQueueDto}
          mutate={mutate}
          isLoading={isLoading}
        />
      </fieldset>
    </>
  );
}

export default AddPayment;
